export default __webpack_public_path__ + "static/media/bank-transfer.32caa84f.svg";